const urlUtils = {
    removeProtocol(url) {
        return url.replace(/(^\w+:|^)\/\//, '');
    },
};

export default urlUtils;
